<div aria-live="polite" [class.df-spinner-button--spinning]="isSpinning">
  <span class="df-spinner-button__content"><ng-content></ng-content></span>
  <df-spinner
    *ngIf="isSpinning"
    class="df-spinner-button__spinner"
    [attr.aria-label]="i18n.loading"
    spinnerContext="button"
  ></df-spinner>
</div>
